import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import "./vee-validate";
import vuetify from './plugins/vuetify';

import { VueReCaptcha } from 'vue-recaptcha-v3'
 
// For more options see below
Vue.use(VueReCaptcha, { siteKey: '6LfBkcgUAAAAAKBXOgiOMftenYqJ45A5bE_JJHJl'})


import './components'

import {HTTP} from './http-common'
Vue.prototype.$http = HTTP

Vue.config.productionTip = false

// for printer
import VueHtmlToPaper from 'vue-html-to-paper';
const options = {
  name: '_blank',
  specs: [
    'fullscreen=no',
    'titlebar=no',
    'scrollbars=no',
    'width=900',
    'height=600'
  ],
  styles: [
    'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
    'https://unpkg.com/kidlat-css/css/kidlat.css'
  ]
}
 
Vue.use(VueHtmlToPaper, options);
 
new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
